import { EntityQuery, FilterQueryOp } from 'breeze-client';
import { ReportActivityRecordInfo, ReportActivityType } from '../../models';

const baseQuery = EntityQuery.from('ReportActivityRecordInfos').orderBy('activityDate', true);
const selectLatestActivity = baseQuery.take(1);
const selectEditActivities = baseQuery.where(
  ReportActivityRecordInfo.propName('activityType'),
  FilterQueryOp.NotEquals,
  ReportActivityType.View
);
const selectEditsByReport = (id: string) =>
  selectEditActivities.where(ReportActivityRecordInfo.propName('reportId'), FilterQueryOp.Equals, id);
const selectEditsByDraft = (id: string) =>
  selectEditActivities.where(ReportActivityRecordInfo.propName('draftId'), FilterQueryOp.Equals, id);

export const reportActivityRecordInfoQueries = {
  selectAll: baseQuery,
  selectLatestActivity,
  selectEditActivities,
  selectEditsByReport,
  selectEditsByDraft
};
